<template>
<div>
    <div class="mcc-page-header">
        <div class="mu-d-flex mu-flex-column mu-w-100 mu-gap-04">
            <div class="mcc-row">

                <section class="mcc-col mu-d-flex mu-flex-row">
                    <h1 class="mu-mb-00">User properties</h1>
                    <details class="mcc-popover mcc-popover--bottom-end">
                        <summary class="mcc-button mcc-button--icon-only ">
                            <mcc-icon name="help" aria-hidden="true"></mcc-icon>
                        </summary>
                        <div class="mcc-popover__content">
                            <p>
                                {{ helpText.title }}
                                <a :href="helpText.url" target="_blank">Read more...</a>
                            </p>
                        </div>
                    </details>

                </section>
                <section class="mcc-col mu-d-flex mu-justify-content-end mu-align-items-center">
                    <div role="group" class="mcc-button-group">
                        <router-link :to="CONTEXT_PATH + '/usersgroups/userProperties/new'">
                            <button class="mcc-button mcc-button--primary" id="addPropertyBtn" title="Add property">
                                <mcc-icon name="plus" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Add property</span>
                            </button>
                        </router-link>

                    </div>

                </section>
            </div>

        </div>

    </div>
    <div class="mcc-container--fluid card-padding">
        <nav aria-label="breadcrumb">
            <ol class="mcc-breadcrumb">
                <li>Users & groups</li>
                <li>User properties</li>
                <li class="lastBredCrumpLi">

                </li>
            </ol>
        </nav>
        
        <div class="mcc-row">
            <div class="mcc-col">
                <div style="position:relative">
                    <div v-if="!updateCall" class="spinner-overlay">
                        <div class="spinner-background"></div>
                        <div class="spinner-flex">
                            <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                                <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                            </svg>
                        </div>
                    </div>
                    <div class="mcc-card">
                        <div class="mcc-card__body">
                            <mcc-data-table ref="userPropertiesTable" id="userPropertiesTable"></mcc-data-table>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>
</template>

<script>
import constantMessages from "../../../messages";
import UserPropertyAPI from "../../../services/UserPropertyAPI";
import Table from "@advanced/component-mosaic-table";
import Utils from "@/script_utils";

export default {
    name: "UserPropertyList",
    data() {
        return {
            helpText: constantMessages.BREADCRUMB_HELP["usersgroups.userproperties.list"],
            CONTEXT_PATH: process.env.VUE_APP_CONTEXT_PATH,
            tableObj: null,
            currentPageSize: 10,
            updateCall: true,
            tableData: [],
            filterActive: false,
        };
    },
    mounted() {
        Utils.applyFixedHeaderConfiguration(this);

        if (localStorage.getItem("userProperty") === "userProperty") {
            var storedSize = localStorage.getItem("userPropertyListPageSize");
            if (storedSize != null && storedSize != "") {
                this.currentPageSize = parseInt(storedSize);
            }
            localStorage.removeItem("userPropertyListPageSize");
            localStorage.removeItem("userProperty");
        }

        this.initUserPropertiesTable();
        // if (this.$refs.userPropertiesTable.isReady) {
        //     this.initUserPropertiesTable();
        // } else {
        //     var self = this;
        //     this.$refs.userPropertiesTable.addEventListener("ready", function () {
        //         self.initUserPropertiesTable();
        //     });
        // }
    },
    methods: {
        initUserPropertiesTable() {
            var self = this;
            self.updateCall = false;
            if (this.tableObj != null) {
                this.currentPageSize = this.tableObj.tableContext.store.state.pageSize;
            }
            this.tableObj = window.tableFactory.create(document.getElementById("userPropertiesTable"), {
                bordered: true,
                striped: true,
                emptyTemplate: '<p class="text-center m-0">No user property found</p>',
                loadingTemplate: '<p class="text-center m-0">Loading...</p>',
                columnSearch: false,
                pageSize: self.currentPageSize,
                debounceTime: 1000,
                schema: {
                    properties: {
                        label: {
                            type: "string",
                            title: "Name",
                            sortable: true,
                            template: '<a class="userPropLabel-link" data-id="{{id}}">{{label}}</a>',
                            columnSearch: false
                        },
                        userPropType: {
                            type: "string",
                            title: "Type",
                            sortable: true,
                            columnSearch: false
                        },
                        userPropMandatory: {
                            type: "string",
                            title: "Mandatory",
                            sortable: false,
                            columnSearch: false
                        },
                    }
                },
                data: (
                    start,
                    limit,
                    sortHeader,
                    sortDirection,
                    fullTextQuery,
                    searchColumns
                ) => {
                    if (!self.filterActive) {
                        self.updateCall = false;
                        if (self.tableObj != null) {
                            self.currentPageSize =
                                self.tableObj.tableContext.store.state.pageSize;
                        }
                        if (sortHeader == null) {
                            sortHeader = "label";
                        }
                        if (sortDirection == null) {
                            sortDirection = "asc";
                        }

                        var queryString =
                            "start=" +
                            start +
                            "&length=" +
                            self.currentPageSize +
                            "&sort=" +
                            sortHeader +
                            "&dir=" +
                            sortDirection;

                        return UserPropertyAPI.getUserProperties(queryString).then(result => {
                            var responseData = {
                                totalCount: 0,
                                data: []
                            };
                            responseData.totalCount = result.page.totalElements;
                            if (result.data != null) {
                                responseData.data = result.data;
                            }

                            self.tableData = responseData.data;
                            self.updateCall = true;
                            return responseData;
                        });
                    } else {
                        self.filterActive = false;
                        let responseData = {
                            totalCount: self.filterData.length,
                            data: self.filterData
                        };
                        self.updateCall = true;
                        return responseData;
                    }
                },
                onAfterDataLoad: (start, limit) => {
                    self.updateTemplate();
                }
            });
        },
        updateTemplate() {
            var self = this;
            this.$refs.userPropertiesTable
                .querySelectorAll('td [class="userPropLabel-link"]')
                .forEach(btn => {
                    btn.addEventListener("click", e => {
                        localStorage.setItem("userPropertyListPageSize", this.tableObj.tableContext.store.state.pageSize);
                        var targetEle = e.target;
                        if (targetEle != null) {
                            var reference = $(targetEle).attr("data-id");
                            self.$router.push(
                                self.CONTEXT_PATH + "/usersgroups/userProperties/" + reference.trim()
                            );
                        }
                    });
                });
        },

    },
}
</script>
